import React, { Component } from 'react';
import GenericTable from 'screens/components/advanced/GenericTable';
import LOOKUP from 'constants/lookup';
import { connect } from 'react-redux';
import Pagination from 'screens/components/basic/Pagination';
import { getPatientOrders, getAllEmployees, clearMemberOrderList, clearEmployeeList } from 'actions/EntityActions';
import { clearFormInput } from 'actions/FormActions';
import { Link } from 'react-router-dom';
import { OrderStatus } from 'constants/enums';
import Grid from 'screens/components/basic/Grid';
import { ordersListCrumb } from 'utils/breadcrumbInfo';
import SearchFields from './searchFields';
import CardSimple from 'screens/components/basic/CardSimple';
import PageHeader from 'screens/components/basic/PageHeader';

const pageName = "orderList";

class OrderList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            activePage: 1,
            itemsPerPage: 25,
            memberId: null,
            orderBy: 'DESC',
            sortBy: 'Id'
        };

        this.getOrders = this.getOrders.bind(this);
        this.sort = this.sort.bind(this);
    }

    componentWillMount() {
        this.getEmployees();
        this.cleanSearch();
    }

    componentWillUnmount() {
        this.props.clearMemberOrderList();
        this.props.clearEmployeeList();
    }

    getEmployees = () => {
        const model = {
            id: 0,
            firstName: "",
            lastName: "",
            role: "",
            status: 'Active',
            orderBy: "DESC",
            sortBy: "FirstName"
        }

        this.props.getEmployees(model);
    }

    getPatientOrders(patientId = null, page = null) {
        const model = {
            branchId: this.props.branchId,
            page: page || this.state.activePage,
            itemsPerPage: this.state.itemsPerPage,
            orderNumber: this.props.orderNumber || null,
            orderDate: null,
            orderEndDate: this.props.endDate || null,
            orderStartDate: this.props.startDate || null,
            patientFirstName: this.props.recipientFirstName || "",
            employeeId: this.props.employeeId || null,
            patientId: patientId,
            employeeFirstName: "",
            status: this.props.status || "None",
            total: null,
            orderBy: this.state.orderBy,
            sortBy: this.state.sortBy
        }

        if (page && patientId) {
            this.setState(pState => {
                return {
                    ...pState,
                    activePage: page,
                    memberId: patientId
                };
            }, () => this.props.getPatientOrders(model));
        } else {
            this.props.getPatientOrders(model);
        }
    }

    search = () => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: 1,
                sortBy: "Id",
                orderBy: "DESC",
                memberId: null
            };
        }, () => this.getPatientOrders());
    }


    cleanSearch = () => {
        this.props.clearFormInput(`${this.props.name}OrderNumberFilter`);
        this.props.clearFormInput(`${this.props.name}StartDate`);
        this.props.clearFormInput(`${this.props.name}EndDate`);
        this.props.clearFormInput(`${this.props.name}EmployeeId`);
        this.props.clearFormInput(`${this.props.name}Status`);
        this.props.clearFormInput("orderListFirstNameFilter");

        // REDO
        setTimeout(() => {
            this.search();
        }, 100);
    }

    changePage = (e) => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: e
            };
        }, () => this.getPatientOrders(this.state.memberId));
    }


    getOrders = () => {
        return (this.props.patientOrders.list || []).map(order => {
            return {
                Id: (<Link to={`/admin/orders/detail/${order.orderNumber}`}> {order.orderNumber} </Link>),
                CreatedDate: order.orderDate,
                PatientFirstName: order.recipient !== " " ? <span className='pointer' onClick={() => this.getPatientOrders(order.memberId, 1)}>{order.recipient}</span> : 'Anonymous',
                EmployeeFirstName: order.employee !== " " ? order.employee : '',
                total: `$${order.total.toFixed(2)}`
            };
        });
    }

    sort(sortBy) {
        this.setState(prevState => {
            return {
                ...prevState,
                orderBy: prevState.orderBy === 'DESC' ? 'ASC' : 'DESC',
                sortBy: sortBy
            }
        }, this.getPatientOrders);
    }


    render() {
        const pOrders = this.props.patientOrders;
        const s = this.state;
        const p = this.props;

        const employeeOptions = (p.employees || []).map(item => {
            return {
                text: `${item.firstName} ${item.lastName}`,
                value: item.id.toString()
            };
        });

        let orderStatus = [];
        for (const [key, value] of Object.entries(OrderStatus)) {
            orderStatus.push({
                text: key,
                value: value
            });
        }

        return (
            <Grid headerContent={ordersListCrumb}>
                <PageHeader title={LOOKUP.menu.admin.orders.text} />
                <CardSimple className="p-1">
                    <SearchFields
                        pageName={pageName}
                        cleanSearch={this.cleanSearch}
                        search={this.search}
                        employeeOptions={employeeOptions}
                    />
                </CardSimple>
                <CardSimple>
                    <GenericTable
                        multiSelectable={false}
                        enableSelectAll={false}
                        displaySelectAll={false}
                        adjustForCheckbox={false}
                        displayRowCheckbox={false}
                        selectable={false}
                        columns={LOOKUP.menu.admin.orderListTableColumns}
                        rows={this.getOrders()}
                        orderBy={this.state.orderBy}
                        sortBy={this.state.sortBy}
                        sort={this.sort}
                        stripedRows={true}
                    />
                    <Pagination
                        length={pOrders.total || 0}
                        itemsPerPage={s.itemsPerPage}
                        activePage={s.activePage}
                        onPageChange={this.changePage}
                        maxButtons={4}
                    />
                </CardSimple>
            </Grid>
        );
    }
}


function mapStatetoProps(state) {
    return {
        patientOrders: state.entity.patientOrders,
        employees: state.entity.employeeList,
        //SEARCH FIELD
        employeeId: state.form.orderListEmployeeId,
        startDate: state.form.orderListStartDate ? new Date(state.form['orderListStartDate']) : null,
        endDate: state.form.orderListEndDate ? new Date(state.form['orderListEndDate']) : null,
        status: state.form.orderListStatus,
        orderNumber: state.form.orderListOrderNumberFilter,
        branchId: state.common.branchId,
        recipientFirstName: state.form.orderListFirstNameFilter
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getPatientOrders: (model) => dispatch(getPatientOrders(model)),
        getEmployees: () => dispatch(getAllEmployees()),
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        clearMemberOrderList: () => dispatch(clearMemberOrderList()),
        clearEmployeeList: () => dispatch(clearEmployeeList())
    };
}

export default connect(mapStatetoProps, mapDispatchToProps)(OrderList);
